// reducer.js

export interface Facility {
    id: number;
    created_at: string;
    updated_at: string;
    created_by_id: null;
    updated_by_id: null;
    name: string;
    code: null;
}

export interface FacilityState {
    data: Facility[];
    error: string | null;
}

export interface Action {
    type: string;
    payload: any;
}

const facilityInitialState: FacilityState = {
    data: [],
    error: null,
};

export const facilityReducer = (
    state: FacilityState = facilityInitialState,
    action: Action
): FacilityState => {
    switch (action.type) {
        case "GET_FACILITY_SUCCESS":
            return { ...state, data: action.payload };
        case "GET_FACILITY_ERROR":
            return { ...state, error: action.payload };
        default:
            return state;
    }
};
